@if (!viewMode) {
  <div class="row">
    <div class="col-2">
      <div class="d-flex align-items-center justify-content-between mb-3">
        <h5 class="mb-0 fw-semibold">Chapters</h5>
        <span class="text-info pointer" (click)="addChapter(submitChapterModal)" ngbTooltip="Add new chapter" alt="Add new chapter"><i class="ri-add-circle-fill fs-18"></i></span>
      </div>
      <ngx-simplebar class="file-manager-chapter-scroll">
        @if (chapters.length === 0) {
          <div class="d-flex align-items-center justify-content-center p-3" style="height: 20vh;">
            <div class="text-center">
              <p class="text-muted">Chapters are empty.</p>
            </div>
          </div>
        }
        @if (chapters.length > 0) {
          <ul class="list-group mb-1">
            @for (chapter of chapters; track chapter; let i = $index) {
              <li class="list-group-item list-group-item-action pointer" [class.active]="chapter == currentChapter" (click)="changeChapter(chapter, i)">
                <div class="d-flex align-items-center">
                  <div class="flex-grow-1">
                    <div class="d-flex">
                      <div class="flex-shrink-0">
                        <i class="ri-file-list-2-line align-middle me-1"></i>
                        <span class="file-list-link">{{ chapter.name ? chapter.name : 'Chapter-' + (i+1) }}</span>
                        @if (chapter.status) {
                          <span ngbTooltip="There are questions that have errors in this chapter" container="body" class="text-warning ri-error-warning-fill align-middle ms-2"></span>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="flex-shrink-0">
                    <span class="text-success me-2 pointer" (click)="editChapter($event, i)" ngbTooltip="Edit chapter" container="body" alt="Edit chapter"><i class="ri-pencil-fill"></i></span>
                    <span class="text-danger pointer" (click)="openDeleteChapterModal($event, chapter, i)" ngbTooltip="Delete chapter" container="body" alt="Delete chapter"><i class="ri-close-circle-fill"></i></span>
                  </div>
                </div>
              </li>
            }
          </ul>
        }
      </ngx-simplebar>
    </div>
    <div class="col-10">
      @if (currentChapter) {
        <div>
          <div class="d-flex align-items-center justify-content-between mb-3">
            <h5 class="mb-0 fw-semibold">Questions</h5>
            <button class="btn btn-primary" (click)="addQuestion()">+ Add New Question</button>
          </div>
          @if (currentChapter.status && currentChapter.questions.length === 0) {
            <div class="text-center">
              <p class="text-danger">Chapter can not be empty!</p>
            </div>
          }
          <ngx-simplebar class="file-manager-question-scroll">
            <div ngbAccordion activeIds="static-1" [closeOthers]="true" class="custom-accordionwithicon accordion-border-box">
              @for (question of currentChapter.questions; track question; let q = $index) {
                <div ngbAccordionItem  id="question-{{ q+1 }}">
                  <h2 ngbAccordionHeader class="accordion-header border-0 bg-transparent d-flex w-100 justify-content-between align-items-center">
                    <button ngbAccordionButton>
                      <span >{{ question.name ? question.name : 'Question-' + (q+1) }}</span>
                      @if (question.status) {
                        <span class="ms-3 text-danger"> *There are required fields in this question that have not been filled</span>
                      }
                      <span type="button" ngbTooltip="Duplicate Question" container="body" class="btn btn-sm btn-info add-btn ms-auto me-2" (click)="duplicateQuestion($event, question)"><i class="ri-file-copy-2-line"></i></span>
                      <span type="button" ngbTooltip="Preview Question" container="body" class="btn btn-sm btn-success add-btn me-2" (click)="viewQuestion($event, q)"><i class="ri-eye-line"></i></span>
                      <span type="button" ngbTooltip="Delete Question" container="body" class="btn btn-sm btn-danger add-btn me-3" (click)="openDeleteQuestionModal($event, deleteQuestionModal, q)"><i class="ri-delete-bin-5-line"></i></span>
                    </button>
                  </h2>
                  <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                      <ng-template>
                        <app-chapter-questions [themeList]="themeList" [question]="question" [questionID]="'chapter-' + currentChapterIndex + '-question-' + q"></app-chapter-questions>
                      </ng-template>
                    </div>
                  </div>
                </div>
              }
            </div>
          </ngx-simplebar>
        </div>
      }
    </div>
  </div>
}

@if (viewMode && chapters.length === 0) {
  <div class="row">
    <div class="col-12">
      <div class="text-center">
        <h5 class="text-warning">There are no Chapters & Questions in this questionnaire</h5>
      </div>
    </div>
  </div>
}

@if (viewMode && chapters.length > 0) {
  <div class="row">
    <div class="col-2">
      <div class="d-flex align-items-center justify-content-between mb-3">
        <h5 class="mb-0 fw-semibold">Chapters</h5>
      </div>
      <ngx-simplebar class="file-manager-chapter-scroll">
        <ul class="list-group mb-1">
          @for (chapter of chapters; track chapter; let i = $index) {
            <li class="list-group-item list-group-item-action pointer" [class.active]="chapter == currentChapter" (click)="changeChapter(chapter, i)">
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <div class="d-flex">
                    <div class="flex-shrink-0">
                      <i class="ri-file-list-2-line align-middle me-1"></i>
                      <span class="file-list-link">{{ chapter.name ? chapter.name : 'Chapter-' + (i+1) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          }
        </ul>
      </ngx-simplebar>
    </div>
    <div class="col-10">
      @if (currentChapter) {
        <div>
          <div class="d-flex align-items-center justify-content-between mb-3">
            <h5 class="mb-0 fw-semibold">Questions {{ report ? '(' + currentChapter.questions.length + ')' : '' }}</h5>
            @if (report) {
              <h5 class="mb-0 fw-semibold">Chapter Score:
                <span class="badge fs-16" [ngStyle]="{'background-color': getColor(currentChapter.chapter_score)}">{{ currentChapter.chapter_score }}%</span>
                <span class="ms-2 badge fs-16 bg-primary">{{ calcResponseTimeMinutes(calcResponseTime(currentChapter.questions[0].answer!.time_start, currentChapter.questions[currentChapter.questions.length-1].answer!.time_end)) }}</span>
              </h5>
            }
          </div>
          <ngx-simplebar class="file-manager-question-scroll">
            <div ngbAccordion activeIds="static-1" [closeOthers]="true" class="custom-accordionwithicon accordion-border-box">
              @for (question of currentChapter.questions; track question; let q = $index) {
                <div ngbAccordionItem  id="question-{{ q+1 }}">
                  <h2 ngbAccordionHeader class="accordion-header border-0 bg-transparent d-flex w-100 justify-content-between align-items-center">
                    <button ngbAccordionButton>
                      <span [ngClass]="report ? 'me-3' : 'me-auto'">{{ question.name ? question.name : 'Question-' + (q+1) }}</span>
                      @if (report) {
                        <span class="me-3"><span class="badge fs-12" [ngStyle]="{'background-color': getColor(question.answer?.gs)}">{{ question.answer?.gs }}%</span></span>
                      }
                      @if (report) {
                        <span class="me-auto"><span class="badge fs-12 bg-primary">{{ calcResponseTimeMinutes(calcResponseTime(question.answer!.time_start, question.answer!.time_end)) }}</span></span>
                      }
                    </button>
                  </h2>
                  <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                      <ng-template>
                        <app-view-chapter-question [report]="report" [question_summary]="true" [chapter_name]="'baseline'" [lang_code]="lang_code" [question]="question" [questionID]="'-question-' + q"></app-view-chapter-question>
                      </ng-template>
                    </div>
                  </div>
                </div>
              }
            </div>
          </ngx-simplebar>
        </div>
      }
    </div>
  </div>
}

<ng-template #submitChapterModal let-modal>
  <div class="modal-content">
    <div class="modal-header p-3">
      <h4 class="card-title mb-0">{{ title }}</h4>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
      <div class="mb-3">
        <label for="name" class="form-label">Chapter Name</label>
        <input type="text" class="form-control" id="name" placeholder="Enter Chapter Name. Default is Chapter-{{ editMode ? chapterIndex+1 : chapters.length+1 }}" [(ngModel)]="chapterName">
      </div>
      <div class="text-end">
        <button type="button" (click)="saveChapter()" class="btn btn-primary btn-load">
          <span class="d-flex justify-content-center">
            @if (submitted && spinner) {
              <span class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </span>
            }
            <span [ngClass]="submitted && spinner ? 'ms-2' : ''"> {{ editMode ? 'Update' : 'Create' }} </span>
          </span>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #deleteChapterModal let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close" (click)="modal.close('Close click')"></button>
    </div>
    <div class="modal-body">
      <div class="mt-2 text-center">
        <lord-icon src="https://cdn.lordicon.com/gsqxdxog.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style="width:100px;height:100px"></lord-icon>
        <div class="alert alert-danger">
          <p class="mb-0 text-uppercase">Once done, this action cannot be undone!!!</p>
        </div>
        <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
          <h4>Are you Sure You want to delete</h4>
          <h4><span class="fw-semibold text-warning">{{ selectedChapter.name ? selectedChapter.name : 'Chapter-' + (chapterIndex+1) }}</span>?</h4>
        </div>
      </div>
      <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
        <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal" (click)="modal.close('Close click')">Close</button>
        <button type="button" class="btn w-sm btn-danger btn-load" (click)="deleteChapter()">
          <span class="d-flex justify-content-center">
            @if (submitted && spinner) {
              <span class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </span>
            }
            <span [ngClass]="submitted && spinner ? 'ms-2' : ''">Yes, Delete It!</span>
          </span>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #viewQuestionModal let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close" (click)="modal.close('Close click')"></button>
    </div>
    @if (currentChapter) {
      <div class="modal-body p-4">
        <app-view-chapter-question [question_index]="selectedQuestionIndex" [question_length]="currentChapter.questions.length" [chapter_name]="currentChapter.name ? currentChapter.name : 'Chapter-' + (currentChapterIndex+1)" [lang_code]="lang_code" [question]="selectedQuestion" [questionID]="'question-' + selectedQuestionIndex"></app-view-chapter-question>
      </div>
    }
  </div>
</ng-template>

<ng-template #deleteQuestionModal let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close" (click)="modal.close('Close click')"></button>
    </div>
    <div class="modal-body">
      <div class="mt-2 text-center">
        <lord-icon src="https://cdn.lordicon.com/gsqxdxog.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style="width:100px;height:100px"></lord-icon>
        <div class="alert alert-danger">
          <p class="mb-0 text-uppercase">Once done, this action cannot be undone!!!</p>
        </div>
        <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
          <h4>Are you Sure You want to delete</h4>
          <h4>
            <span class="fw-semibold text-warning">
              {{ 'Question-' + (questionIndex+1) }} of {{ chapters[currentChapterIndex].name ? chapters[currentChapterIndex].name : 'Chapter-' + (currentChapterIndex+1) }}
            </span>
            ?
          </h4>
        </div>
      </div>
      <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
        <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal" (click)="modal.close('Close click')">Close</button>
        <button type="button" class="btn w-sm btn-danger btn-load" (click)="deleteQuestion()">
          <span class="d-flex justify-content-center">
            @if (submitted && spinner) {
              <span class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </span>
            }
            <span [ngClass]="submitted && spinner ? 'ms-2' : ''">Yes, Delete It!</span>
          </span>
        </button>
      </div>
    </div>
  </div>
</ng-template>